// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","dotStyle":"bL2UQXfgadyZYggVxcaB4","handleStyle":"_48LRw2jgyGj5z3Mla9blb","railStyle":"_1qdPmNVA830dxtsytCbf7C","container":"_3lmgThRf9-fBJTxBfTXEnH"};